import moment from 'moment';

export const getDaysOfTheWeek = (startDate: string, length = 7) =>
  Array.from({ length }, (_, index) => moment(startDate).add(index, 'days').format('YYYY-MM-DD'));
